import React from "react";
import { Form } from "react-bootstrap";

const AdminScreenHeader = ({
  title,
  searchTerm,
  setSearchTerm,
  placeholder = "Search...",
  showSearch = true,
}) => {
  return (
    <div className="d-flex justify-content-between align-items-center mb-2 all-users admin-screen-header">
      <div>{title}</div>
      {showSearch && (
        <Form className="d-flex">
          <Form.Control
            type="text"
            placeholder={placeholder}
            className="me-2"
            style={{ width: "150px", fontSize: "13px" }}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </Form>
      )}
    </div>
  );
};

export default AdminScreenHeader;
